import React from 'react';

export const VaccinationTable = (props) => {
  const rowEntries = props.vaccinationList;

  const content = (rowEntries === [] || rowEntries === undefined) ? (<></>) :
    (
    <>
      <h4>Vaccination List</h4>
      <table className='table table-striped' aria-labelledby="tabelLabel">
        <thead>
          <tr>
            <th>Vaccine Name</th>
            <th>Date</th>
            <th>Valid</th>
            <th>Cvx Code</th>
            <th>Lot Number</th>
            <th>Mfg Code</th>
            <th>Provider</th>
          </tr>
        </thead>
        <tbody>
            {rowEntries.map((row, index) => 
              row.antigenList.reduce(
                (previousValue, currentValue) => previousValue === (currentValue.evaluationStatus === 2 || currentValue.evaluationStatus === 0),
                true) === false
             ? 
            <tr key={index}>
                <td><span className="text-danger">{row.vaccineName}</span></td>
                <td><span className="text-danger">{row.vaccinationDate}</span></td>
                <td><span className="text-danger">{row.antigenList.reduce(
                (previousValue, currentValue) => previousValue === (currentValue.evaluationStatus === 2 || currentValue.evaluationStatus === 0),
                true).toString()}
                </span></td>
                <td><span className="text-danger">{row.cvxCode}</span></td>
                <td><span className="text-danger">{row.lotNumber}</span></td>
                <td><span className="text-danger">{row.manufacturerCode}</span></td>
            </tr>
              :
            <tr key={index}>
              <td>{row.vaccineName}</td>
              <td>{row.vaccinationDate}</td>
              <td>{row.antigenList.reduce(
                (previousValue, currentValue) => previousValue === (currentValue.evaluationStatus === 2 || currentValue.evaluationStatus === 0),
                true).toString()}
              </td>
              <td>{row.cvxCode}</td>
              <td>{row.lotNumber}</td>
              <td>{row.manufacturerCode}</td>
              <td>{(row.provider !== null) ? row.provider.name : "not available"}</td>
            </tr>
          )}
        </tbody>
      </table>
    </>
    )

  return content;
}
